const CODE_MESSAGES = {
  BAD_CREDENTIALS: "Credenciales incorrectas.",
  USER_DISABLED: "Tu cuenta está deshabilitada. Contacta con soporte.",
  USER_NOT_VERIFIED: "Tu cuenta aún no está verificada.",
  DUPLICATED_USER: "El email ya está registrado.",
  NOT_FOUND: "No se encontró el recurso solicitado.",
  BITPANDA_ERROR: "Error al comunicarse con Bitpanda.",
  AWS_S3_ERROR: "Error al guardar el archivo.",
  ERROR_400: "Solicitud inválida.",
  ERROR_401: "No autorizado.",
  ERROR_403: "No tienes permisos para realizar esta acción.",
  ERROR_404: "No se encontró el recurso solicitado.",
  ERROR_500: "Se produjo un error interno.",
};

const STATUS_MESSAGES = {
  400: "Solicitud inválida.",
  401: "No autorizado.",
  403: "No tienes permisos para realizar esta acción.",
  404: "No se encontró el recurso solicitado.",
  500: "Se produjo un error interno.",
};

const DESCRIPTION_PATTERNS = [
  {
    pattern: /Invalid value for field '([^']+)'/i,
    message: (match) => `Valor inválido para el campo '${match[1]}'.`,
  },
  {
    pattern: /Missing required parameter '([^']+)'/i,
    message: (match) => `Falta el parámetro obligatorio '${match[1]}'.`,
  },
  {
    pattern: /Malformed JSON payload/i,
    message: () => "El JSON enviado no es válido.",
  },
  {
    pattern: /Invalid request payload format/i,
    message: () => "El formato del cuerpo de la solicitud no es válido.",
  },
  {
    pattern: /Validation failed/i,
    message: () => "La validación de los datos falló.",
  },
  {
    pattern: /Request payload is missing required fields/i,
    message: () => "Faltan campos obligatorios en la solicitud.",
  },
  {
    pattern: /Unsupported content type '([^']+)'/i,
    message: (match) =>
      `Tipo de contenido no soportado '${match[1]}'. Usa 'application/json'.`,
  },
  {
    pattern: /Endpoint '([^']+)' not found/i,
    message: (match) => `No se encontró el endpoint ${match[1]}.`,
  },
  {
    pattern: /HTTP method '([^']+)' is not supported/i,
    message: (match) =>
      `El método HTTP '${match[1]}' no está soportado para este endpoint.`,
  },
  {
    pattern: /Bad request/i,
    message: () => "Solicitud inválida.",
  },
  {
    pattern: /Bad credentials/i,
    message: () => "Credenciales incorrectas.",
  },
  {
    pattern: /The user is disabled/i,
    message: () => "Tu cuenta está deshabilitada. Contacta con soporte.",
  },
  {
    pattern: /The account is not verified/i,
    message: () => "Tu cuenta aún no está verificada.",
  },
  {
    pattern: /The email is already in the database/i,
    message: () => "El email ya está registrado.",
  },
  {
    pattern: /Not Authorized/i,
    message: () => "No autorizado.",
  },
  {
    pattern: /Forbidden/i,
    message: () => "No tienes permisos para realizar esta acción.",
  },
  {
    pattern: /Not found/i,
    message: () => "No se encontró el recurso solicitado.",
  },
  {
    pattern: /Internal server error/i,
    message: () => "Se produjo un error interno.",
  },
  {
    pattern: /AWS S3 error/i,
    message: () => "Error al guardar el archivo.",
  },
  {
    pattern: /Something went wrong calling Bitpanda/i,
    message: () => "Error al comunicarse con Bitpanda.",
  },
];

function mapDescription(description) {
  if (!description) return null;
  for (const rule of DESCRIPTION_PATTERNS) {
    const match = description.match(rule.pattern);
    if (match) {
      return rule.message(match);
    }
  }
  return null;
}

export function getApiErrorMessage(data, status) {
  if (data?.error && CODE_MESSAGES[data.error]) {
    return CODE_MESSAGES[data.error];
  }

  const description = data?.description || data?.message;
  const mapped = mapDescription(description);
  if (mapped) return mapped;

  if (description) return description;

  return STATUS_MESSAGES[status] || "Error inesperado en la API.";
}
